import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\toutline: 1px solid #7b62ff;\n\tpointer-events: none;\n\tposition: fixed;\n\tz-index: 9999999;\n"]);

  _templateObject17 = function () {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbackground: orangered;\n\tleft: 0;\n\ttop: 0;\n\ttransform: translate(0, -120%);\n\twhite-space: nowrap;\n\tz-index: 2;\n"]);

  _templateObject16 = function () {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbackground: #7b62ff;\n\tbottom: 0;\n\tright: 0;\n\ttransform: translateY(120%);\n\twhite-space: nowrap;\n"]);

  _templateObject15 = function () {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tright: 0;\n\ttop: 50%;\n\ttransform: translate(120%, -50%);\n"]);

  _templateObject14 = function () {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tleft: 0;\n\ttop: 50%;\n\ttransform: translate(-120%, -50%);\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbottom: 0;\n\tleft: 50%;\n\ttransform: translate(-50%, 120%);\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tleft: 50%;\n\ttop: 0;\n\ttransform: translate(-50%, -120%);\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbackground: orangered;\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: orangered;\n\tborder-radius: 2px;\n\tcolor: white;\n\tdisplay: block;\n\tfont-size: 7px;\n\tfont-weight: bold;\n\tline-height: 1;\n\tmargin: 0;\n\tpadding: 1px 2px;\n\tposition: absolute;\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-left: 1px solid orangered;\n\tleft: 50%;\n\topacity: 0.5;\n\tposition: absolute;\n\twidth: 0;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-top: 1px solid orangered;\n\theight: 0;\n\topacity: 0.5;\n\tposition: absolute;\n\ttop: 50%;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n\toutline: 1px solid #7b62ff;\n\tz-index: 999999;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\toutline: 1px solid orangered;\n\tpointer-events: none;\n\tposition: fixed;\n\tz-index: 9999999;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '@wp-g2/styles';
export var ElementOutline = css(_templateObject());
export var ParentElementOutline = css(_templateObject2(), ElementOutline);
export var RulerX = css(_templateObject3());
export var RulerY = css(_templateObject4());
export var RulerL = css(_templateObject5(), RulerX);
export var RulerR = css(_templateObject6(), RulerX);
export var RulerT = css(_templateObject7(), RulerY);
export var RulerB = css(_templateObject8(), RulerY);
export var BaseLabel = css(_templateObject9());
export var Label = css(_templateObject10(), BaseLabel);
export var LabelT = css(_templateObject11(), Label);
export var LabelB = css(_templateObject12(), Label);
export var LabelL = css(_templateObject13(), Label);
export var LabelR = css(_templateObject14(), Label);
export var ParentSizeLabel = css(_templateObject15(), BaseLabel);
export var SizeLabel = css(_templateObject16(), BaseLabel);
export var Resizer = css(_templateObject17());